module.exports = __webpack_public_path__ + "img/map-bg-small-black.c46a359c.svg";